import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { CreateBonusAssignmentResponse, CreateBonusAssignmentVariables } from '../types';

export const createBonusAssignmentMutation = gql`
  mutation PayrollCreateBonusAssignment($input: CreateBonusAssignmentInput!) {
    payrollCreateBonusAssignment(input: $input) {
      code
      success
      message
      data {
        id
      }
    }
  }
`;

export const createBonusAssignment = (queryVariables: CreateBonusAssignmentVariables) =>
  graphQLApi<CreateBonusAssignmentResponse, CreateBonusAssignmentVariables>({
    query: createBonusAssignmentMutation,
    queryVariables,
  });

export default createBonusAssignment;
